import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { Nillable } from '@web/utils';
import { AdminOrderItemAttributeResponse } from './admin-order-item-attribute.response';
import {
  OrderItemRefundSummaryResponse,
  ProductType,
} from '@web/shared/module/shop';
import { AdminOrderItemComponentGroupResponse } from './admin-order-item-component-group.response';

@jsonObject
export class AdminOrderItemResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly subName?: Nillable<string>;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(String)
  public readonly type!: ProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Number)
  public readonly unitPrice!: number;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(OrderItemRefundSummaryResponse)
  public readonly refundSummary?: Nillable<OrderItemRefundSummaryResponse>;

  @jsonArrayMember(AdminOrderItemAttributeResponse)
  public readonly attributes?: Nillable<AdminOrderItemAttributeResponse[]>;

  @jsonArrayMember(AdminOrderItemComponentGroupResponse)
  public readonly componentGroups?: Nillable<
    AdminOrderItemComponentGroupResponse[]
  >;
}
